export default __webpack_public_path__ + "static/media/hellsteps.5f63027f.png";